import { render, staticRenderFns } from "./PopulateDetail.vue?vue&type=template&id=4cab2b4b"
import script from "./PopulateDetail.vue?vue&type=script&lang=js"
export * from "./PopulateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports